import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative h-screen min-h-[680px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/6cab62cb1c937b2a47829db3bb696d72.jpg"
          alt="Florida luxury home"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/55 to-black/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full text-center px-6">
        <p className="text-amber-300 text-sm font-semibold tracking-widest uppercase mb-4 animate-fade-in">
          Florida Real Estate Expert
        </p>
        <h1 className="text-5xl md:text-7xl font-bold text-white leading-tight mb-6">
          Amparo Jarquin
          <br />
          <span className="text-amber-400">Real Estate Excellence</span>
        </h1>
        <p className="text-white/80 text-lg md:text-xl max-w-2xl mx-auto mb-10 leading-relaxed">
          Amparo Jarquin brings years of Florida real estate expertise to help you buy or sell with confidence, clarity, and care.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/listings"
            className="px-8 py-4 bg-amber-500 hover:bg-amber-600 text-white font-semibold rounded-full transition-colors whitespace-nowrap cursor-pointer text-sm tracking-wide"
          >
            View Listings
          </Link>
          <Link
            to="/request"
            className="px-8 py-4 bg-transparent border-2 border-white text-white hover:bg-white hover:text-gray-900 font-semibold rounded-full transition-colors whitespace-nowrap cursor-pointer text-sm tracking-wide"
          >
            Request Information
          </Link>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white/60 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-xs tracking-widest uppercase">Scroll</span>
        <i className="ri-arrow-down-line"></i>
      </div>
    </section>
  );
}
